import React, { FunctionComponent } from 'react';

import { default as MuiTooltip, TooltipProps } from '@mui/material/Tooltip';

const Tooltip: FunctionComponent<TooltipProps> = ({
  children,
  title,
}: TooltipProps) => {
  return <MuiTooltip title={title}>{children}</MuiTooltip>;
};
export default Tooltip;
